import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const PartnerLoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'PayzoPay - Partner Girişi';
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await api.partnerLogin({ email, password });

            localStorage.setItem('partner_token', res.data.token);
            localStorage.setItem('partner_user', JSON.stringify(res.data.user));

            const isPartnerDomain = window.location.hostname.startsWith('partner');
            navigate(isPartnerDomain ? '/dashboard' : '/partner/dashboard');
        } catch (error) {
            alert(error.response?.data?.message || 'Giriş başarısız.');
        } finally {
            setIsLoading(false);
        }
    };

    // Stiller
    const containerStyle = { minHeight: '100vh', display: 'flex', backgroundColor: '#121212', color: '#e0e0e0', fontFamily: 'sans-serif' };
    const leftSideStyle = {
        flex: '55%', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 60px',
        background: 'linear-gradient(135deg, #1e1e1e 0%, #121212 100%)',
        borderRight: '1px solid #333'
    };
    const rightSideStyle = { flex: '45%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' };
    const formCardStyle = {
        width: '100%', maxWidth: '400px', backgroundColor: '#1e1e1e',
        padding: '40px', borderRadius: '8px', border: '1px solid #333', boxShadow: '0 4px 20px rgba(0,0,0,0.4)'
    };
    const inputGroupStyle = { marginBottom: '20px', position: 'relative' };
    const labelStyle = { display: 'block', marginBottom: '8px', fontSize: '0.9em', color: '#aaa', fontWeight: '500' };
    const inputStyle = {
        width: '100%', padding: '12px 12px 12px 40px', backgroundColor: '#2d2d2d', border: '1px solid #555',
        borderRadius: '4px', color: '#e0e0e0', fontSize: '1em', outline: 'none', boxSizing: 'border-box',
        transition: 'border-color 0.3s'
    };
    const iconStyle = { position: 'absolute', left: '12px', top: '38px', color: '#888' };
    const buttonStyle = {
        width: '100%', padding: '12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px',
        fontSize: '1em', fontWeight: '600', cursor: isLoading ? 'not-allowed' : 'pointer',
        transition: 'background 0.3s',
        marginTop: '10px'
    };

    return (
        <div style={containerStyle}>
            {/* Sol Taraf (Görsel Alan) - Mobilde gizlenebilir */}
            <div style={{ ...leftSideStyle, display: window.innerWidth < 1024 ? 'none' : 'flex' }}>
                <div style={{ position: 'relative', zIndex: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                        <div style={{ width: '50px', height: '50px', borderRadius: '12px', background: 'linear-gradient(135deg, #10b981, #059669)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.3)' }}>
                            <i className="fas fa-building" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>PayzoPay Partner</span>
                    </div>

                    <h1 style={{ fontSize: '3.5em', fontWeight: 'bold', lineHeight: '1.1', marginBottom: '20px' }}>
                        Partner<br />
                        <span style={{ background: 'linear-gradient(to right, #34d399, #60a5fa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                            Portalı
                        </span>
                    </h1>
                    <p style={{ fontSize: '1.2em', color: '#9ca3af', maxWidth: '450px' }}>
                        İşlemlerinizi takip edin, mütabakatınızı kontrol edin ve raporlarınıza anında erişin.
                    </p>
                </div>
                {/* Dekoratif Arkaplan Efektleri */}
                <div style={{ position: 'absolute', top: '10%', right: '10%', width: '400px', height: '400px', backgroundColor: 'rgba(16, 185, 129, 0.15)', borderRadius: '50%', filter: 'blur(100px)' }}></div>
                <div style={{ position: 'absolute', bottom: '10%', left: '10%', width: '300px', height: '300px', backgroundColor: 'rgba(37, 99, 235, 0.1)', borderRadius: '50%', filter: 'blur(80px)' }}></div>
            </div>

            {/* Sağ Taraf (Form Alanı) */}
            <div style={rightSideStyle}>
                <div style={formCardStyle}>
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '1.8em', fontWeight: 'bold', marginBottom: '10px' }}>Partner Girişi</h2>
                        <p style={{ color: '#aaa' }}>Hesabınıza giriş yapın</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div style={inputGroupStyle}>
                            <label style={labelStyle}>E-posta</label>
                            <i className="fas fa-envelope" style={iconStyle}></i>
                            <input type="email" placeholder="ornek@firma.com" value={email} onChange={e => setEmail(e.target.value)} style={inputStyle} required />
                        </div>

                        <div style={inputGroupStyle}>
                            <label style={labelStyle}>Şifre</label>
                            <i className="fas fa-lock" style={iconStyle}></i>
                            <input type="password" placeholder="******" value={password} onChange={e => setPassword(e.target.value)} style={inputStyle} required />
                        </div>

                        <button type="submit" style={buttonStyle} disabled={isLoading}>
                            {isLoading ? <i className="fas fa-spinner fa-spin" style={{ marginRight: '10px' }}></i> : null}
                            Giriş Yap
                        </button>
                    </form>

                    <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.9em', color: '#888' }}>
                        Admin girişi için <a
                            href={window.location.hostname.startsWith('partner') ? `${window.location.protocol}//${window.location.host.replace('partner.', '')}/login` : "/login"}
                            style={{ color: '#007bff', textDecoration: 'none' }}
                        >buraya tıklayın</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PartnerLoginPage;